module.exports = __webpack_public_path__ + "img/dxr.2dd9b7c5.webp";